import { createRoute } from '@tanstack/react-router';
import { Route as parent } from './site.tsx';
export const Route = createRoute({ getParentRoute: () => parent, path: 'activity' }).lazy(() =>
  import('./site-activity.lazy.tsx').then((module) => module.Route),
);
